<template>
  <v-container>
    <Loader/>
    <v-row>
      <v-col cols="12" sm="12">
        <b-alert show variant="light" class="alert alert-custom alert-success alert-shadow mb-0">
          <div class="alert-text mt-2">
            <h1 style="color:#000000" class="text-center"><b>Settings</b></h1>
          </div>
        </b-alert>
      </v-col>
    </v-row>
    <v-card flat>
      <v-card-text>
        <v-form class="custom_form" ref="form" v-model="validationRules.valid" lazy-validation>
          <v-row>
            <template v-if="isDeveloperUser">
              <v-col cols="12" sm="6">
                <label style="color: black">Header image</label><br>
                <v-img v-if="editedItem.pdf_header_url" class="mt-2" width="50%" :src="editedItem.pdf_header_url"></v-img>
                <p v-else class="mt-2">N/A</p>
              </v-col>
              <v-col cols="12" sm="6">
                <label style="color: black">Header image</label>
                <v-file-input accept="image/png,image/jpeg,image/jpg" clearable outlined dense class="mt-2"
                              :hint="headerImageHint" persistent-hint
                              :error-messages="headerImageError"
                              @change="validateAndUploadImage($event, 'user_new_pdf_header', pdfImageConstraints.header, 'headerImageError')"
                              show-size></v-file-input>
              </v-col>

              <v-col cols="12" sm="6" class="mt-5">
                <label style="color: black">Watermark image</label><br>
                <v-img v-if="editedItem.pdf_watermark_url" class="mt-2" width="50%" :src="editedItem.pdf_watermark_url"></v-img>
                <p v-else class="mt-2">N/A</p>
              </v-col>
              <v-col cols="12" sm="6" class="mt-5">
                <label style="color: black">Watermark image</label>
                <v-file-input accept="image/png,image/jpeg,image/jpg" clearable outlined dense class="mt-2"
                              :hint="watermarkImageHint" persistent-hint
                              :error-messages="watermarkImageError"
                              @change="validateAndUploadImage($event, 'user_new_pdf_watermark', pdfImageConstraints.watermark, 'watermarkImageError')"
                              show-size></v-file-input>
              </v-col>

              <v-col cols="12" sm="6" class="mt-5">
                <label style="color: black">Logo</label><br>
                <v-img v-if="editedItem.pdf_logo_url" class="mt-2" width="50%" :src="editedItem.pdf_logo_url"></v-img>
                <p v-else class="mt-2">N/A</p>
              </v-col>
              <v-col cols="12" sm="6" class="mt-5">
                <label style="color: black">Logo</label>
                <v-file-input accept="image/png,image/jpeg,image/jpg" clearable outlined dense class="mt-2"
                              @change="uploadFile($event, 'user_new_pdf_logo')" show-size></v-file-input>
              </v-col>
            </template>

            <v-col cols="12" sm="6" :class="isDeveloperUser ? 'mt-5' : ''">
              <label style="color: black">Signature image</label><br>
              <v-img v-if="editedItem.signature_url" class="mt-2" width="50%" :src="editedItem.signature_url"></v-img>
              <p v-else class="mt-2">N/A</p>
            </v-col>
            <v-col cols="12" sm="6" :class="isDeveloperUser ? 'mt-5' : ''">
              <label style="color: black">Signature image</label>
              <v-file-input accept="image/png" clearable outlined :rules="signatureFileRules" dense class="mt-2"
                            @change="uploadFile($event, 'user_new_signature')" show-size></v-file-input>
            </v-col>

            <v-col cols="12" sm="6" class="mt-5">
              <label style="color: black">Stamp image</label><br>
              <v-img v-if="editedItem.stamp_url" class="mt-2" width="50%" :src="editedItem.stamp_url"></v-img>
              <p v-else class="mt-2">N/A</p>
            </v-col>
            <v-col cols="12" sm="6" class="mt-5">
              <label style="color: black">Stamp image</label>
              <v-file-input accept="image/png" clearable outlined :rules="stampFileRules" dense class="mt-2"
                            @change="uploadFile($event, 'user_new_stamp')" show-size></v-file-input>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :disabled="!validationRules.valid" class="btn btn-success" dark text @click="saveItem(editedItem)">
          Update
        </v-btn>
      </v-card-actions>
      <v-col cols="12">
        <div v-if="errors != undefined && errors.length >= 0" role="alert" v-bind:class="{ show: errors.length }"
             class="alert fade alert-danger">
          <div class="alert-text" v-for="(error, i) in errors" :key="i">
            {{ error }}
          </div>
        </div>
      </v-col>
    </v-card>
  </v-container>
</template>

<script>
import {mapState} from "vuex";
import Loader from "@/view/content/Loader";
import {CLEAR_USER_ERRORS, UPDATE_PROFILE} from "@/core/services/store/users.module";
import {UPLOAD_S3_FILE} from "@/core/services/store/uploads.module";
import Swal from "sweetalert2";

export default {
  name: "profile",
  components: {
    Loader
  },
  data() {
    return {
      editedItem: {},
      show: false,
      showC: false,
      headerImageError: [],
      watermarkImageError: [],
      pdfImageConstraints: {
        header: {minW: 740, minH: 72, maxW: 3000, maxH: 600},
        watermark: {minW: 520, minH: 520, maxW: 3000, maxH: 3000},
      },
      validationRules: {
        valid: true,
        nameRules: [
          v => !!v || "This field is required",
          v => (v && v.length >= 3) || "Must be greater than or equal to 3 characters",
          v => (v && v.length <= 50) || "Must be less than or equal to 50 characters"
        ],
        descRules: [
          v => !!v || "This field is required",
          v => (v && v.length >= 3) || "Must be greater than or equal to 3 characters",
          v => (v && v.length <= 300) || "Must be less than or equal to 300 characters"
        ],
        fullDescRules: [
          v => !!v || "This field is required",
          v => (v && v.length >= 3) || "Must be greater than or equal to 3 characters",
          v => (v && v.length <= 1000) || "Must be less than or equal to 1000 characters"
        ],
        midRules: [
          v => !!v || "This field is required",
          v => (v && v.length >= 3) || "Must be greater than or equal to 3 characters",
          v => (v && v.length <= 100) || "Must be less than or equal to 100 characters"
        ],
        degRules: [
          v => !!v || "This field is required",
          v => (v && v.length >= 3) || "Must be greater than or equal to 3 characters",
          v => (v && v.length <= 100) || "Must be less than or equal to 100 characters"
        ],
        uniRules: [
          v => !!v || "This field is required",
          v => (v && v.length >= 3) || "Must be greater than or equal to 3 characters",
          v => (v && v.length <= 200) || "Must be less than or equal to 200 characters"
        ],
        ageRules: [
          v => !!v || "This field is required",
          v => (v && v.length >= 1) || "Must be greater than or equal to 1 characters",
          v => (v && v.length <= 3) || "Must be less than or equal to 3 characters"
        ],
        phoneRules: [
          v => !!v || "This field is required",
          v => (v && v.length >= 3) || "Must be greater than or equal to 3 characters",
          v => (v && v.length <= 20) || "Must be less than or equal to 20 characters"
        ],
        genderRules: [
          v => !!v || "This field is required"
        ],
        sourceRules: [
          v => !!v || "This field is required"
        ],
        emailRules: [
          v => !!v || "This field  is required",
          v => (v && v.length <= 100) || "Must be less than 100 characters",
          v => /.+@.+\..+/.test(v) || "E-mail must be valid"
        ],
        selectRules: [
          (v) => {
            if (!v || v.length < 1)
              return 'This field is required';
            else return true;
          }
        ],
        passwordRules: [
          v => !!v || "Password is required",
          v => (v && v.length <= 20) || "Password must be less than or equal to 20 characters",
          v => (v && v.length >= 6) || "Password must be at least 6 characters"
        ],
        newPasswordConfirmationRules: [
          v => !!v || "Type confirm password"
        ],
      },
    }
  },
  mounted() {
    this.editedItem = this.$store.state.auth.user
  },
  methods: {
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    uploadFile(file, key) {
      if (file) {
        this.$store.dispatch(CLEAR_USER_ERRORS);
        let formData = new FormData()
        formData.append("file", file, file.name)
        this.$store.dispatch(UPLOAD_S3_FILE, {data: formData}).then((data) => {
          this.editedItem[key] = data.records
        })
      }
    },
    validateAndUploadImage(file, key, constraints, errorKey) {
      this[errorKey] = [];

      if (!file) {
        this.editedItem[key] = null;
        return;
      }

      if (file.size > 20000000) {
        this[errorKey] = ['File size should be less than 20 MB.'];
        return;
      }

      const objectUrl = window.URL.createObjectURL(file);
      const img = new Image();
      img.onload = () => {
        const width = img.naturalWidth;
        const height = img.naturalHeight;
        window.URL.revokeObjectURL(objectUrl);

        if (width < constraints.minW || height < constraints.minH) {
          this[errorKey] = [
            `Image is too small (${width} × ${height} px). Minimum ${constraints.minW} × ${constraints.minH} px.`,
          ];
          return;
        }

        if (width > constraints.maxW || height > constraints.maxH) {
          this[errorKey] = [
            `Image is too large (${width} × ${height} px). Maximum ${constraints.maxW} × ${constraints.maxH} px.`,
          ];
          return;
        }

        this.uploadFile(file, key);
      };
      img.onerror = () => {
        window.URL.revokeObjectURL(objectUrl);
        this[errorKey] = ['Invalid image file. Please upload a valid PNG or JPG image.'];
      };
      img.src = objectUrl;
    },
    optionalImageFileRules() {
      return [
        (file) => {
          if (file && file.size > 0) {
            return file.size < 20000000 || 'File size should be less than 20 MB!';
          }

          return true;
        },
      ];
    },
    saveItem(item) {
      if (this.$refs.form.validate()) {
        this.$store.dispatch(CLEAR_USER_ERRORS);
        this.$store.dispatch(UPDATE_PROFILE, { data: item }).then((data) => {
          Swal.fire('', data._metadata.message, 'success').then(() => {
            window.location.reload();
          })
        })
      }
    }
  },
  computed: {
    isDeveloperUser() {
      return Number(this.$store.state.auth.user.type) === 2;
    },
    headerImageHint() {
      const c = this.pdfImageConstraints.header;
      return `Recommended 1500 × 150 px. Min ${c.minW} × ${c.minH} px, Max ${c.maxW} × ${c.maxH} px.`;
    },
    watermarkImageHint() {
      const c = this.pdfImageConstraints.watermark;
      return `Recommended 1000 × 1000 px. Min ${c.minW} × ${c.minH} px, Max ${c.maxW} × ${c.maxH} px.`;
    },
    signatureFileRules() {
      return this.optionalImageFileRules();
    },
    stampFileRules() {
      return this.optionalImageFileRules();
    },
    ...mapState({
      errors: state => state.users.errors
    })
  }
};
</script>
